"use client"
import React, { useState, useEffect } from 'react';
import './Pricing.css';
import { styled, alpha } from '@mui/system';
import { motion } from 'framer-motion';
import PricingCard from '../../Components/PricingCard';
import { Switch } from '@mui/material';
import { Sparkels } from '../../Components';

  export default function Pricing() {

    const [width, setWidth] = useState(0);

    const [requests, setRequests] = useState('50K');
    const [yearly, setYearly] = useState(false);

    useEffect(() => {
      document.body.classList.add('darkMode');
      document.body.classList.add('dark');
        if (typeof window !== 'undefined') {
            setWidth(window.innerWidth);
            window.addEventListener('resize', () => {
              console.log(window.innerWidth);
              setWidth(window.innerWidth);
            });    
        }
    }, []);

  return (
    <div className='pricing_container'>
      {/* Floating particles background */}
      <div className="floating-particles">
        {[...Array(20)].map((_, i) => (
          <div 
            key={i} 
            className="particle" 
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 1}s`,
              animationDuration: `${15 + Math.random() * 10}s`
            }}
          />
        ))}
      </div>

      <div className='pricing_content'>
      <label className='pricing_switch'>
      <Switch onChange={() => setYearly(!yearly)} checked={yearly} />
      <span>Yearly Subscription</span>
      </label>
      <div className='pricing_slider'>
      
    </div>
    <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="absolute top-[80px] mb-[50px] flex flex-col gap-4 items-center justify-center px-4"
      >
        <h3 className='pricing_title'>
          Powerful Cloud
          <br />
          Chess Analysis
        </h3>
        <Sparkels />
        <div className="font-extralight text-base md:text-xl text-center text-neutral-200 py-0 relative bottom-[20px] w-[80%] max-w-[1000px]">
        {requests} Requests / Month
        </div>
      </motion.div>
        <div className='pricing_cards_container'>
          {[...Array(3)].map((_, index) => (<PricingCard yearly={yearly} plan={index}/>))}
        </div>
        </div>
    </div>
    
  )
}
